import { useEffect, useRef } from 'react'
import type { ComponentProps } from 'react'
import DevicePanel from './DevicePanel'

// 디바이스 [설정] 서랍 — 명세서 시트의 [설정]·편집 모드의 [정보 수정] 이 같이 쓴다. 오른쪽에서 열리고,
// 바깥 누르기·Esc·머리의 ✕ 로 닫는다 (서랍 안 목록이 열려 있으면 Esc 는 목록이 먼저 닫는다 — 브라우저 기본)
export default function DeviceDrawer({ onClose, ...panel }: Omit<ComponentProps<typeof DevicePanel>, 'onClose'> & { onClose: () => void }) {
  const closeRef = useRef(onClose)
  useEffect(() => { closeRef.current = onClose })
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !e.defaultPrevented) closeRef.current() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <div className="fixed inset-0 z-50 bg-black/30 flex justify-end" onMouseDown={onClose}>
      <div role="dialog" aria-label="디바이스 설정" className="w-[400px] max-w-full h-full overflow-y-auto p-3" onMouseDown={e => e.stopPropagation()}>
        <DevicePanel {...panel} onClose={onClose} />
      </div>
    </div>
  )
}
